var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 433 314 314q21 21 51.5 21t51.5-21q22-22 22-52t-22-52L564 277q-21-21-51.5-21T461 277L95 643q-22 22-22 52t22 52q21 21 51.5 21t51.5-21l314-314z"
  })));
};
export { SvgChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCMmFXVjNRbTk0UFNJd0lEQWdNVEF5TkNBeE1ESTBJaUI0Yld4dWN6MGlhSFIwY0RvdkwzZDNkeTUzTXk1dmNtY3ZNakF3TUM5emRtY2lQanh3WVhSb0lHUTlJazAxTVRJZ05ETXpiRE14TkNBek1UUnhNakVnTWpFZ05URXVOU0F5TVhRMU1TNDFMVEl4Y1RJeUxUSXlJREl5TFRVeWRDMHlNaTAxTWt3MU5qUWdNamMzY1MweU1TMHlNUzAxTVM0MUxUSXhWRFEyTVNBeU56ZE1PVFVnTmpRemNTMHlNaUF5TWkweU1pQTFNblF5TWlBMU1uRXlNU0F5TVNBMU1TNDFJREl4ZERVeExqVXRNakZzTXpFMExUTXhOSG9pTHo0OEwzTjJaejQ9Ig==";